"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
var Lang_js_1 = require("../../Lang.js");
var paths = [
    '/app/notifications/',
    '/app/notifications/preferences/',
];
var getCurrentPath = function () {
    if (typeof window === 'undefined')
        return '';
    return window.location.pathname || '';
};
var NotificationsSidebar = function (_a) {
    var _b = _a.unreadCount, unreadCount = _b === void 0 ? 0 : _b;
    var _c = (0, react_1.useState)(0), tabIndex = _c[0], settabIndex = _c[1];
    var _d = (0, react_1.useState)(false), isDrawerOpen = _d[0], setIsDrawerOpen = _d[1];
    var theme = (0, styles_1.useTheme)();
    var isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down('sm'));
    (0, react_1.useEffect)(function () {
        var currentPath = getCurrentPath();
        var activeTab = paths.findIndex(function (path) { return currentPath == path; });
        settabIndex(activeTab >= 0 ? activeTab : 0);
    }, []);
    var handleChange = function (_event, newtabIndex) {
        settabIndex(newtabIndex);
        var path = paths[newtabIndex] || '/';
        if (typeof window !== 'undefined') {
            window.location.href = path;
        }
        if (isMobile)
            setIsDrawerOpen(false);
    };
    var tabContent = (react_1.default.createElement(material_1.Box, { sx: {
            width: 250,
            borderRight: 1,
            borderColor: 'divider',
            bgcolor: 'grey.50',
        } },
        react_1.default.createElement(material_1.Tabs, { orientation: "vertical", variant: "scrollable", value: tabIndex, onChange: handleChange },
            react_1.default.createElement(material_1.Tab, { label: react_1.default.createElement(react_1.default.Fragment, null, (0, Lang_js_1.__)('Notifications') + ((unreadCount > 0) ? ' (' + unreadCount + ')' : '')) }),
            react_1.default.createElement(material_1.Tab, { label: (0, Lang_js_1.__)('Preferences') }))));
    return (react_1.default.createElement("div", { className: "seminar-leader-sidebar" }, isMobile ? (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', padding: '2px' } },
        react_1.default.createElement("span", { style: { marginRight: '2px', fontSize: '12px' } }, (0, Lang_js_1.__)('Menu')),
        react_1.default.createElement(material_1.IconButton, { color: "inherit", "aria-label": (0, Lang_js_1.__)('Open messaging menu'), edge: "start", onClick: function () { return setIsDrawerOpen(true); }, size: "small" },
            react_1.default.createElement(Menu_1.default, null)),
        react_1.default.createElement(material_1.Drawer, { anchor: "left", open: isDrawerOpen, onClose: function () { return setIsDrawerOpen(false); } }, tabContent))) : (tabContent)));
};
exports.default = NotificationsSidebar;
